
<ion-content [style.--background]="scanActive ? '#00000000': '#fff'">
  <ion-row class="scanner-buttons" [hidden]="!scanActive">
    <ion-col size="8" offset="2">
      <ion-button (click)="stopScanner()" color="danger" expand="block">Cancel Scan</ion-button>
    </ion-col>
  </ion-row>
<div class="scan-box" [hidden]="!scanActive">

</div>
</ion-content>
